/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Execution_Context_LoadingInputs */

const en_task_execution_context_loading = /** @type {(inputs: Task_Execution_Context_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading checklist data…`)
};

const pt_br2_task_execution_context_loading = /** @type {(inputs: Task_Execution_Context_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando dados do checklist…`)
};

/**
* | output |
* | --- |
* | "Loading checklist data…" |
*
* @param {Task_Execution_Context_LoadingInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_execution_context_loading = /** @type {((inputs?: Task_Execution_Context_LoadingInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Execution_Context_LoadingInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_execution_context_loading(inputs)
	return pt_br2_task_execution_context_loading(inputs)
});